<dx-popup title="Job" [width]="600" [height]="'auto'" [(visible)]="visible" [hideOnOutsideClick]="false" (onHiding)="onHiding($event)">
    @if (!job.completed) {
        <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'complete', type: 'success', onClick: complete }">
        </dxi-popup-toolbar-item>
    }
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Save', type: 'success', onClick: save }">
    </dxi-popup-toolbar-item>
    <dxi-popup-toolbar-item widget="dxButton" location="after" [options]="{ text: 'Cancel', type: 'danger', onClick: cancel }">
    </dxi-popup-toolbar-item>
    <dx-form [formData]="job">
        @if (job.jobTypeId !== 1) {
            <dxi-form-item dataField="weight" class="pb-3"> </dxi-form-item>
        }
        <dxi-form-item itemType="group" caption="Job Info">
            <dxi-form-item dataField="rental.customer.displayName" [label]="{ text: 'Customer' }" [editorOptions]="{ readOnly: true }">
            </dxi-form-item>
            <dxi-form-item dataField="jobType.name" [label]="{ text: 'Job Type' }" [editorOptions]="{ readOnly: true }"> </dxi-form-item>
            <dxi-form-item dataField="displayAddress" [label]="{ text: 'Service Address' }" [editorOptions]="{ readOnly: true }">
            </dxi-form-item>
            <dxi-form-item dataField="startDate" editorType="dxDateBox" [editorOptions]="{ type: 'datetime', readOnly: true }">
            </dxi-form-item>
            <dxi-form-item dataField="endDate" editorType="dxDateBox" [editorOptions]="{ type: 'datetime', readOnly: true }">
            </dxi-form-item>
            <dxi-form-item
                dataField="rental.driverInstructions"
                [label]="{ text: 'Driver Instructions' }"
                editorType="dxTextArea"
                [editorOptions]="{ height: '75px', readOnly: true }"
            >
            </dxi-form-item>
        </dxi-form-item>
    </dx-form>
</dx-popup>
